import { useState, useEffect } from 'react';

/**
 * Кастомний хук для визначення орієнтації пристрою
 * @returns isPortrait - true якщо portrait, false якщо landscape
 */
export const useOrientation = (): boolean => {
  const [isPortrait, setIsPortrait] = useState<boolean>(
    window.innerHeight > window.innerWidth
  );

  useEffect(() => {
    const checkOrientation = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };

    // Перевіряємо орієнтацію при завантаженні
    checkOrientation();

    // Відслідковуємо зміни орієнтації
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  return isPortrait;
};
